<template>
    <el-dialog :visible="visible" class="ah-detail-dialog variable-statement-detail-editor-item-detail-dialog" @open="onOpen" @close="onClose">
        <template slot="title">
            <div class="title">
                <span>{{ this.isEditMode ? "編輯" : "新增" }}子項目</span>
            </div>
        </template>

        <div class="detail-row" style="padding-top: 30px">
            <div style="margin-bottom: 20px">
                <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="160px">
                    <div style="margin: 0 auto 20px auto">
                        <el-form-item prop="iteM_NAM" label="名稱">
                            <el-input v-model.trim="form.iteM_NAM" :maxlength="200" style="width: 220px" :show-word-limit="true" />
                        </el-form-item>
                        <el-form-item prop="grP_MEM" label="說明">
                            <el-input v-model.trim="form.grP_MEM" maxlength="50" show-word-limit />
                        </el-form-item>
                        <el-form-item prop="accsno" label="歸屬會計科目">
                            <el-select v-model="form.accsno" size="small" filterable style="width: 320px">
                                <el-option v-for="option in accountingItems" :key="option.key" :label="option.label" :value="option.value">
                                    <span style="display: inline-block; width: 70px">{{ option.accno }}</span>
                                    <span style="display: inline-block">{{ option.accnam }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="accsno">
                            <template slot="label">
                                其他建議科目
                                <ah-tip>
                                    <div>於編列收支項目時，可以選擇的會計科目選項。</div>
                                    <div>如未設定，則自動使用歸屬會計科目。</div>
                                </ah-tip>
                            </template>
                            <el-select v-model="form.suggestedAccItems" size="small" filterable reserve-keyword multiple style="width: 320px">
                                <el-option v-for="option in accountingItems" :key="option.key" :label="option.label" :value="option.accno">
                                    <span style="display: inline-block; width: 70px">{{ option.accno }}</span>
                                    <span style="display: inline-block">{{ option.accnam }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="main-action">
                <el-button v-if="isEditMode" @click="onDelete"> 刪除 </el-button>
                <div v-else></div>
                <div>
                    <el-button @click="onClose">取消</el-button>
                    <el-button type="primary" class="primary-action" @click="onSubmit">
                        <span v-if="isEditMode">儲存</span>
                        <span v-else>新增</span>
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        visible: Boolean,
        fullList: {
            type: Array,
            default: () => [],
        },
        data: null,
        activeGroupName: String,
        accountingItems: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            form: {
                iteM_NAM: '',
                grP_MEM: null,
                accnam: null,
                accno: null,
                accsno: null,
                suggestedAccItems: [],
            },
            rules: {
                iteM_NAM: [{ required: true, message: '請輸入名稱' }],
            },
        };
    },
    computed: {
        isEditMode() {
            return !!this.data;
        },
        isNameDuplicated() {
            const found = _.chain(this.fullList)
                .filter((o) => o.iteM_NAM !== this.data?.iteM_NAM)
                .find(['iteM_NAM', this.form.iteM_NAM])
                .value();

            if (found) {
                this.$message({
                    showClose: true,
                    message: '子項目名稱不可重複',
                    type: 'error',
                });
                return true;
            }
            return false;
        },
    },
    methods: {
        onOpen() {
            this.$nextTick(() => {
                this.$refs.form.resetFields();
                if (this.isEditMode) {
                    this.form.iteM_NAM = this.data.iteM_NAM;
                    this.form.grP_MEM = this.data.grP_MEM;
                    this.form.accnam = this.data.accnam;
                    this.form.accno = this.data.accno;
                    this.form.accsno = _.find(this.accountingItems, ['accno', this.data.accno])?.key;
                    this.form.suggestedAccItems = _.map(this.data.suggestedAccItems, 'accno');
                } else {
                    this.form = {
                        iteM_NAM: '',
                        grP_MEM: null,
                        accnam: null,
                        accno: null,
                        accsno: null,
                        suggestedAccItems: [],
                    };
                }
            });
        },
        onClose() {
            this.$emit('close');
        },
        async onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return false;
                this.onMutateItem();
                return true;
            });
        },
        async onMutateItem() {
            if (this.isNameDuplicated) return;

            if (this.form.accsno) {
                const FOUND_ACCSNO = _.find(this.accountingItems, ['value', this.form.accsno]);
                this.form.accnam = FOUND_ACCSNO.accnam;
                this.form.accno = FOUND_ACCSNO.accno;
            }

            if (this.form.suggestedAccItems.length) {
                this.form.suggestedAccItems.forEach((accno, i) => {
                    const FOUND = _.find(this.accountingItems, ['accno', accno]);
                    this.form.suggestedAccItems[i] = {
                        acItemSno: FOUND.value,
                        accnam: FOUND.accnam,
                        accno: FOUND.accno,
                    };
                });
            }

            if (this.isEditMode) this.$emit('update', this.form);
            else this.$emit('add', this.form);
            this.onClose();
        },

        async onDelete() {
            try {
                await this.$confirm('確定要刪除？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.$emit('delete');
                this.onClose();
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>

<style lang="scss">
.ah-detail-dialog.variable-statement-detail-editor-item-detail-dialog {
    .el-dialog {
        max-width: 560px;
    }
    .title {
        text-align: center;
    }
    .main-action {
        display: flex;
        justify-content: space-between;
    }
}
</style>
